<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import ItemAPI from "@/services/items/itemsAPI";
import { required } from "vuelidate/lib/validators";
import CheckModal from "@/components/CheckModal";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import inspeccionesSeguridadAPI from "../../../services/standards/inspeccionesSeguridad/inspeccionesSeguridadAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "4.2.4 Inspecciones de seguridad",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {
    return {
      title: "4.2.4 Inspecciones de seguridad",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Inspecciones de seguridad",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/inspecciones-seguridad`,
        },
        {
          text: "Evidencia inspección",
        },
        {
          text: "Editar",
          active: true,
        },
      ],

      itemData: null,
      userSelected: null,
      Datalist: [],
      inspeccion: [],
      selectec: null,
      usersList: [],
      employee: null,
      file: null,
      empleado: null,
      dataI: null,
      loading: true,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
      evidencia: {
        file: null,
        safety_inspections_id: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      safety_inspections_id: null,
      lista: null,
      listaSeguimientos: [],
      employeeID: null,
      item: null,
      itemData: null,
      form_submitting: false,
      full_name: null,
      submitted: false,
    };
  },

  validations: {
    file: {
      required,
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(28)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getShowE() {
      inspeccionesSeguridadAPI
        .getShowE(this.$route.params.id)
        .then((response) => {
          this.inspeccion = response.data;
          this.evidencia = {
            file: response.data.file,
            employee_id: response.data.employee_id,
            companies_id: response.data.companies_id,
            safety_inspections_id: response.data.safety_inspections_id,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.evidencia.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/4.2.4/${this.evidencia.safety_inspections_id}/evidencia/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/4.2.4/${this.evidencia.safety_inspections_id}/evidencia/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.evidencia.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading = true;
      let response = await this.uploadDocument();
      if (response) {
        const data = {
          file: this.evidencia.file,
          safety_inspections_id: this.evidencia.safety_inspections_id,
          employee_id: this.inspeccion.employee_id,
          companies_id: this.evidencia.companies_id,
        };
        inspeccionesSeguridadAPI
          .updateE(this.$route.params.id, data)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 48,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false;
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  this.$router.go(-1);
                }, 2000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido actualizar, error carga documentos!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 2000)
      }
    },

    getUsersByID() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getUsersByID();
    this.getItemData();
    this.getShowE();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe garantizar el cumplimiento de las
                      restricciones y recomendaciones médico laborales
                      realizadas por parte de la Empresa Promotora de Salud
                      (EPS) o Administradora de Riesgos Laborales (ARL)
                      prescritas a los trabajadores para la realización de sus
                      funciones. Para dar cumplimiento a dichas recomendaciones,
                      se deberá realizar una reunión con el jefe del proceso, un
                      integrante del COPASST y el colaborador, donde se analicen
                      las recomendaciones o restricciones que tiene y si puede o
                      no continuar con las labores que viene desarrollando, de
                      no ser así se deberá adecuar el puesto de trabajo,
                      reubicar al trabajador o realizar la readaptación laboral
                      cuando se requiera.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right">
                  <div @click="goBack" class="btn btn-secondary m-l-5" id="tooltip">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                </div>
              </div>
              <hr />

              <div class="row mt-2">
                <h4 class="header-title col-4">Responsable:</h4>
                <h4 class="header-title col-8">
                  {{ this.inspeccion.full_name }}
                </h4>
              </div>

              <div class="row mt-2">
                <h4 class="header-title col-4">Inspección a realizar</h4>
                <h4 class="header-title col-8">
                  {{
                    this.inspeccion.name === "Otro"
                      ? this.inspeccion.other
                      : this.inspeccion.name
                  }}
                </h4>
              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="inspeccion.file
                        ? getFile(inspeccion.file)
                        : `Selecciona un archivo...`
                        " drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr />
              </form>
            </div>
          </div>
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
